
import {
  FETCH_FORM_FAIL,
  FETCH_FORM_REQUEST,
  FETCH_FORM_SUCCESS,
} from "../../ActionType/FormType/FormType";

export const getFormReducer = (
  state = { loading: true, forms: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_FORM_REQUEST:
      return {
        loading: true,
        forms: action.payload,
      };
    case FETCH_FORM_SUCCESS:
      return {
        loading: false,
        forms: action.payload,
        error: "",
      };
    case FETCH_FORM_FAIL:
      return {
        loading: false,
        forms: action.payload,
        error: "",
      };
    default:
      return state;
  }
};
